import React from 'react';
import { Card, Avatar, Tag, Button, Tooltip } from 'antd';
import {
  TrophyOutlined,
  VideoCameraOutlined,
  StarOutlined,
  EyeOutlined,
  CrownOutlined,
  UserOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './LeaderboardCard.css';

const LeaderboardCard = ({ rank, user, isTopThree }) => {
  const navigate = useNavigate();

  const getRankIcon = () => {
    if (rank === 1) return <CrownOutlined className="rank-icon gold" />;
    if (rank === 2) return <TrophyOutlined className="rank-icon silver" />;
    if (rank === 3) return <TrophyOutlined className="rank-icon bronze" />;
    return null;
  };

  const getRankBadge = () => {
    if (rank === 1) return { text: 'Gold', class: 'badge-gold' };
    if (rank === 2) return { text: 'Silver', class: 'badge-silver' };
    if (rank === 3) return { text: 'Bronze', class: 'badge-bronze' };
    return { text: 'default', class: '' };
  };

  const getRankClass = () => {
    if (rank === 1) return 'rank-1';
    if (rank === 2) return 'rank-2';
    if (rank === 3) return 'rank-3';
    return '';
  };

  const handleViewDetails = () => {
    // Navigate to affiliate detail page using affiliate_id if available, otherwise use nim_nip
    const targetPath = user.affiliate_id ? `/affiliate/${user.affiliate_id}` : `/history/${user.nim_nip}`;
    navigate(targetPath);
  };

  if (isTopThree) {
    return (
      <Card className={`leaderboard-card podium-card ${getRankClass()}`}>
        <div className="podium-rank">
          {getRankIcon()}
          <span className="rank-number">#{rank}</span>
        </div>

        <div className="user-avatar-container">
          <Avatar
            size={100}
            icon={<UserOutlined />}
            className="user-avatar"
            style={{ backgroundColor: '#14B8A6' }}
          />
          {rank <= 3 && (
            <div className={`podium-badge ${getRankBadge(rank).class}`}>
              {getRankBadge(rank).text}
            </div>
          )}
        </div>

        <div className="user-info">
          <h3 className="user-name">{user.name}</h3>
          <p className="user-id">{user.nim_nip}</p>
          <Tag color={user.role === 'student' ? 'blue' : 'green'} className="user-role">
            {user.role === 'student' ? 'Mahasiswa' : 'Dosen'}
          </Tag>
        </div>

        <div className="stats-container">
          <div className="stat-item">
            <StarOutlined className="stat-icon" />
            <div className="stat-info">
              <div className="stat-value">{user.total_points}</div>
              <div className="stat-label">Poin</div>
            </div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <VideoCameraOutlined className="stat-icon" />
            <div className="stat-info">
              <div className="stat-value">{user.total_videos}</div>
              <div className="stat-label">Video</div>
            </div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <SafetyCertificateOutlined className="stat-icon" />
            <div className="stat-info">
              <div className="stat-value">{user.total_certifications || 0}</div>
              <div className="stat-label">Sertifikat</div>
            </div>
          </div>
        </div>

        <Tooltip title="Lihat riwayat kontribusi lengkap">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={handleViewDetails}
            className="view-details-btn"
            block
          >
            Lihat Detail
          </Button>
        </Tooltip>
      </Card>
    );
  }

  return (
    <Card className="leaderboard-card list-card" hoverable>
      <div className="list-card-content">
        <div className="left-section">
          <div className="rank-badge">
            <span className="rank-number">#{rank}</span>
          </div>

          <Avatar
            size={60}
            icon={<UserOutlined />}
            className="user-avatar-small"
            style={{ backgroundColor: '#14B8A6' }}
          />

          <div className="user-info-compact">
            <h4 className="user-name-compact">{user.name}</h4>
            <p className="user-id-compact">{user.nim_nip}</p>
            <Tag 
              color={user.role === 'student' ? 'blue' : 'green'} 
              className="user-role-compact"
            >
              {user.role === 'student' ? 'Mahasiswa' : 'Dosen'}
            </Tag>
          </div>
        </div>

        <div className="right-section">
          <div className="stats-compact">
            <Tooltip title="Total Poin">
              <div className="stat-compact">
                <StarOutlined className="stat-icon-compact" />
                <span className="stat-value-compact">{user.total_points}</span>
              </div>
            </Tooltip>

            <Tooltip title="Total Video">
              <div className="stat-compact">
                <VideoCameraOutlined className="stat-icon-compact" />
                <span className="stat-value-compact">{user.total_videos}</span>
              </div>
            </Tooltip>

            <Tooltip title="Total Sertifikat">
              <div className="stat-compact">
                <SafetyCertificateOutlined className="stat-icon-compact" />
                <span className="stat-value-compact">{user.total_certifications || 0}</span>
              </div>
            </Tooltip>
          </div>

          <Tooltip title="Lihat detail">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={handleViewDetails}
              className="view-btn-compact"
            >
              Detail
            </Button>
          </Tooltip>
        </div>
      </div>
    </Card>
  );
};

export default LeaderboardCard;